/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAccountProfileEditLoadingIcon {
    className: string;
}

const AccountProfileEditLoadingIcon: React.FC<IAccountProfileEditLoadingIcon> = ({ className }) => (
    <div className={`${className}__loading-icon`} />
);

export default AccountProfileEditLoadingIcon;
